// api.js

import axiosInstance from "../axiosInstance";

export const userService = {
  fetchUserByEmail: async (email, clientId) => {
    try {
      const response = await axiosInstance.get(
        `/generate-token?email=${encodeURIComponent(email)}`,
      );
      if (clientId) {
        const clientResponse = await axiosInstance.post("/authentication", {
          strategy: "jwt",
          accessToken: response.data.accessToken,
          client: clientId,
        });
        return { ...clientResponse.data, user: response.data.user };
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
